export default __webpack_public_path__ + "static/media/amy_photo.6264f622.jpeg";